// ============================================================
// useAmbiance.js
// Chemin : src/components/Discussion/hooks/useAmbiance.js
// ============================================================

import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// ── Config des ambiances ───────────────────────────────────
export const useAmbianceConfig = () => {
  const { t } = useTranslation();
  return {
  //  nuit: { label: `🌌 ${t('discussion.label1')}`, icon: '✨', colors: ['#0f172a', '#000000'], textColor: 'text-white' },
  //  feu:  { label: `🔥 ${t('discussion.label2')}`, icon: '🔥', colors: ['#ff7a18', '#7e2a0a'], textColor: 'text-white' },
 //   mer:  { label: `🌊 ${t('discussion.label3')}`, icon: '💧', colors: ['#06b6d4', '#0369a1'], textColor: 'text-black' },
  //  love: { label: `❤️ ${t('discussion.label4')}`, icon: '❤️', colors: ['#f472b6', '#dc2626'], textColor: 'text-black' },
  };
};

const AMBIANCE_SOUNDS = {
  nuit: '/sounds/nuit.mp3',
  feu:  '/sounds/feu.mp3',
  mer:  '/sounds/mer.mp3',
  love: '/sounds/love.mp3',
  voeux: "/sounds/voeux.mp3",
  zen: "/sounds/zen.mp3",
  pluie: "/sounds/pluie.mp3",
  anniversaire: "/sounds/anniversaire.mp3",
};

export const useAmbiance = () => {
  const [soundOn, setSoundOn] = useState(false);
  const audioRef              = useRef(null);
  const mediaRef              = useRef(null);

  const stopAmbianceSound = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
    }
    if (mediaRef.current) {
      mediaRef.current.stop();
      mediaRef.current.release();
      mediaRef.current = null;
    }
    setSoundOn(false);
  };

  const playAmbianceSound = (ambiance) => {
    stopAmbianceSound();
    /* global cordova, Media */
    const isCordova = typeof cordova !== 'undefined' && cordova.file;
    if (isCordova) {
      const src   = cordova.file.applicationDirectory + 'www/sounds/' + ambiance + '.mp3';
      const media = new Media(src, () => {}, (err) => console.error('Media err:', err));
      media.setVolume(0.4);
      media.play({ numberOfLoops: 9999 });
      mediaRef.current = media;
    } else {
      const audio  = new Audio(AMBIANCE_SOUNDS[ambiance]);
      audio.loop   = true;
      audio.volume = 0.4;
      audio.play().catch((e) => console.warn('Audio play err:', e));
      audioRef.current = audio;
    }
    setSoundOn(true);
  };

  useEffect(() => () => stopAmbianceSound(), []);

  return { soundOn, setSoundOn, playAmbianceSound, stopAmbianceSound };
};
